import Analytics, { type AnalyticsPlugin } from 'analytics';

import amplitudePlugin from './plugins/amplitude';
import consolePlugin from './plugins/console';
import type { TypedAnalytics } from './types';

const plugins: AnalyticsPlugin[] = [amplitudePlugin()];

if (process.env.NODE_ENV === 'development') {
  plugins.push(consolePlugin());
}

const base = Analytics({
  app: 'dash',
  plugins,
});

// Track all event session keys so we can clear them on reset
const eventSessionKeys = new Set<string>();

export const analytics: TypedAnalytics = {
  track(event, properties, eventSessionKey) {
    const sessionData = eventSessionKey ? base.storage.getItem(eventSessionKey) : {};
    return base.track(event, {
      ...sessionData,
      ...properties,
    });
  },
  page: base.page,
  identify: base.identify,
  reset: () => {
    base.reset();
    // Clear all event session keys
    eventSessionKeys.forEach((key) => {
      base.storage.removeItem(key, {});
    });
    eventSessionKeys.clear();
  },
  // Set or merge event session data
  setEventSession(key, value) {
    const existing = base.storage.getItem(key) || {};
    const merged = mergeEventSessionProperties(existing, value);
    base.storage.setItem(key, merged);
    eventSessionKeys.add(key);
  },
};

export function mergeEventSessionProperties(existing: Record<string, any>, value: Record<string, any>) {
  return Object.keys(value).reduce(
    (acc, k) => {
      // If the new value is undefined and existing exists, keep existing
      if (value[k] === undefined && existing[k] !== undefined) {
        return acc;
      }
      return { ...acc, [k]: value[k] };
    },
    { ...existing },
  );
}
